import { Box, CheckBox } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import PlannedBreaks from 'modules/shift_management/components/ShiftManagement/PlannedBreaks'
import SavedShiftInformation from 'modules/shift_management/components/ShiftManagement/SavedShiftInformation'
import ShiftLocationPicker from 'modules/shift_management/components/ShiftManagement/ShiftLocationPicker'
import ShiftNotesField from 'modules/shift_management/components/ShiftManagement/ShiftNotesField'
import ShiftOvertimeCheckbox from 'modules/shift_management/components/ShiftManagement/ShiftOvertimeCheckbox'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useSelectionState } from 'modules/shift_management/hooks/useSelection'
import type DefaultShiftWithParamsForm from 'modules/shift_management/lib/forms/DefaultShiftWithParamsForm'
import type PlannedBreak from 'modules/time_planning/store/internal/models/PlannedBreak'

interface Props {
  form: DefaultShiftWithParamsForm
  plannedBreaks: PlannedBreak[]
  onToggleShift: (id: string) => void
}

const SavedShiftItem = ({ form, plannedBreaks, onToggleShift }: Props) => {
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const [{ view }] = useSchedule()
  const { isEnabled: hasSelection } = useSelectionState()
  const isSelected = form.get('is_selected').value
  const borderColor = isSelected ? 'viridian1000' : 'grey400'
  const showLocation = !hasSelection || !view.isByAreas

  const onSelect = () => {
    onToggleShift(form.get('id').value)
  }

  const locationEnabled = hasFeatureFlag('dev_location_work_areas')

  return (
    <Box
      gap="s16"
      padding="s12"
      borderRadius={{ all: 'abs016' }}
      border={{
        all: {
          style: 'solid',
          width: 's2',
          color: borderColor,
        },
      }}
    >
      <Box flexDirection="row" justifyContent="spaceBetween" gap="s6">
        <SavedShiftInformation
          title={form.get('title').value}
          color={form.get('color').value}
          startAt={form.get('start_at').value}
          endAt={form.get('end_at').value}
          overnightShift={!!form.get('overnight_shift').value}
        />
        <Box justifyContent="flexStart">
          <CheckBox checked={isSelected} onClick={onSelect} />
        </Box>
      </Box>

      {isSelected && (
        <Box gap="s16">
          {!!plannedBreaks.length && (
            <PlannedBreaks plannedBreaks={plannedBreaks} showDeleted canManage newVersion />
          )}

          {locationEnabled && (
            <Box gap="s16">
              {showLocation && (
                <ShiftLocationPicker
                  locationField={form.get('location_id')}
                  workAreaField={form.get('work_area_id')}
                  newVersion
                />
              )}
              <ShiftNotesField notesField={form.get('notes')} newVersion />
            </Box>
          )}
          <ShiftOvertimeCheckbox form={form} newVersion />
        </Box>
      )}
    </Box>
  )
}

export default observer(SavedShiftItem)
